(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-collection"] && !Shopify.designMode) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }


  // Helper function to show loading skeleton
  function showLoadingSkeleton() {
    const skeleton = document.getElementById('products-loading-skeleton');
    const collectionWrapper = document.querySelector('.collection-wrapper');
    const productGrid = document.querySelector('.product-grid');
    const loadMoreContainer = document.querySelector('.load-more-container');
    
    if (skeleton) {
      skeleton.style.display = 'flex';
    }
    if (collectionWrapper) {
      collectionWrapper.style.display = 'none';
    }
    if (productGrid) {
      productGrid.style.display = 'none';
    }
    if (loadMoreContainer) {
      loadMoreContainer.style.display = 'none';
    }
  }

  // Helper function to hide loading skeleton
  function hideLoadingSkeleton() {
    const skeleton = document.getElementById('products-loading-skeleton');
    const collectionWrapper = document.querySelector('.collection-wrapper');
    const productGrid = document.querySelector('.product-grid');
    
    if (skeleton) {
      skeleton.style.display = 'none';
    }
    if (collectionWrapper) {
      collectionWrapper.style.display = '';
    }
    if (productGrid) {
      productGrid.style.display = '';
    }
  }

  // Hide skeleton once page is loaded
  window.addEventListener('load', function() {
    // Small delay to ensure products are rendered
    setTimeout(function() {
      hideLoadingSkeleton();
    }, 100);
  });

  // AJAX Sort Functionality - No Page Refresh
  document.addEventListener('DOMContentLoaded', function () {
    const sortSelect = document.querySelector('.sort-select');
    if (sortSelect) {
      sortSelect.addEventListener('change', function (e) {
        e.preventDefault();


        const selectedValue = e.target.value;
        const currentUrl = new URL(window.location.href);
        currentUrl.searchParams.set('sort_by', selectedValue);


        // Show loading skeleton instead of old products
        showLoadingSkeleton();


        // Fetch new content
        fetch(currentUrl.toString())
          .then((response) => response.text())
          .then((html) => {
            // Create a temporary div to parse the response
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = html;


            // Find the product grid in the response
            const newProductGrid = tempDiv.querySelector('.product-grid');
            const newLoadMoreButton = tempDiv.querySelector('.load-more-button');
            const productGrid = document.querySelector('.product-grid');


            if (newProductGrid && productGrid) {
              // Replace the product grid
              productGrid.outerHTML = newProductGrid.outerHTML;
            }


            if (newLoadMoreButton) {
              // Replace load more button if it exists
              const currentLoadMoreButton = document.querySelector('.load-more-button');
              if (currentLoadMoreButton) {
                currentLoadMoreButton.outerHTML = newLoadMoreButton.outerHTML;
              } else {
                // Add load more button if it doesn't exist
                const resultsList = document.querySelector('results-list');
                if (resultsList) {
                  resultsList.insertAdjacentHTML('afterend', newLoadMoreButton.outerHTML);
                }
              }
            } else {
              // No more products - update existing button to show "No More Products"
              const currentLoadMoreButton = document.querySelector('.load-more-button');
              if (currentLoadMoreButton) {
                const buttonText = currentLoadMoreButton.querySelector('.load-more-button__text');
                currentLoadMoreButton.disabled = true;
                currentLoadMoreButton.removeAttribute('data-next-url');
                if (buttonText) {
                  buttonText.textContent = 'No More Products';
                }
              }
            }


            // Update URL without page refresh
            window.history.pushState({}, '', currentUrl.toString());


            // Hide loading skeleton and show products
            hideLoadingSkeleton();
            
            // Show load more button if it exists
            const loadMoreContainer = document.querySelector('.load-more-container');
            if (loadMoreContainer && newLoadMoreButton) {
              loadMoreContainer.style.display = 'flex';
            }


            // Re-attach event listeners
            attachSortListeners();
            attachLoadMoreListener();
            
            // Activate "All" tab when sort changes
            activateAllTab();
          })
          .catch((error) => {
            console.error('Error:', error);
            hideLoadingSkeleton();
            // Fallback to page refresh if AJAX fails
            window.location.href = currentUrl.toString();
          });
      });
    }


    function attachSortListeners() {
      const sortSelect = document.querySelector('.sort-select');
      if (sortSelect) {
        sortSelect.addEventListener('change', function (e) {
          e.preventDefault();


          const selectedValue = e.target.value;
          const currentUrl = new URL(window.location.href);
          currentUrl.searchParams.set('sort_by', selectedValue);


          // Show loading skeleton instead of old products
          showLoadingSkeleton();


          // Fetch new content
          fetch(currentUrl.toString())
            .then((response) => response.text())
            .then((html) => {
              // Create a temporary div to parse the response
              const tempDiv = document.createElement('div');
              tempDiv.innerHTML = html;


              // Find the product grid in the response
              const newProductGrid = tempDiv.querySelector('.product-grid');
              const newLoadMoreButton = tempDiv.querySelector('.load-more-button');
              const productGrid = document.querySelector('.product-grid');


              if (newProductGrid && productGrid) {
                // Replace the product grid
                productGrid.outerHTML = newProductGrid.outerHTML;
              }


              if (newLoadMoreButton) {
                // Replace load more button if it exists
                const currentLoadMoreButton = document.querySelector('.load-more-button');
                if (currentLoadMoreButton) {
                  currentLoadMoreButton.outerHTML = newLoadMoreButton.outerHTML;
                } else {
                  // Add load more button if it doesn't exist
                  const resultsList = document.querySelector('results-list');
                  if (resultsList) {
                    resultsList.insertAdjacentHTML('afterend', newLoadMoreButton.outerHTML);
                  }
                }
              }


              // Update URL without page refresh
              window.history.pushState({}, '', currentUrl.toString());


              // Hide loading skeleton and show products
              hideLoadingSkeleton();
              
              // Show load more button if it exists
              const loadMoreContainer = document.querySelector('.load-more-container');
              if (loadMoreContainer && newLoadMoreButton) {
                loadMoreContainer.style.display = 'flex';
              }


              // Re-attach event listeners
              attachSortListeners();
              attachLoadMoreListener();
              
              // Activate "All" tab when sort changes
              activateAllTab();
            })
            .catch((error) => {
              console.error('Error:', error);
              hideLoadingSkeleton();
              // Fallback to page refresh if AJAX fails
              window.location.href = currentUrl.toString();
            });
        });
      }
    }

    function activateAllTab() {
      const tabsContainer = document.querySelector('.collection-page-tabs');
      if (!tabsContainer) return;

      // Find the "All" tab
      const allTab = tabsContainer.querySelector('.collection-page-tabs__item[data-category="all"]');
      if (!allTab) return;

      // Remove active class from all tabs
      const allTabs = tabsContainer.querySelectorAll('.collection-page-tabs__item');
      allTabs.forEach((tab) => tab.classList.remove('active'));

      // Add active class to "All" tab
      allTab.classList.add('active');

      // Get load more button element
      const loadMoreButton = document.querySelector('.load-more-container');

      // Show all products
      const getAllProducts = document.querySelectorAll('.collection-product-card-item');
      getAllProducts.forEach((product) => {
        product.style.display = 'block';
      });

      // Show load more button for "all" tab
      if (loadMoreButton) {
        loadMoreButton.style.display = 'block';
      }
    }

    function attachLoadMoreListener() {
      const loadMoreButton = document.querySelector('.load-more-button');
      if (loadMoreButton && !loadMoreButton.hasAttribute('data-listener-attached')) {
        loadMoreButton.setAttribute('data-listener-attached', 'true');
        loadMoreButton.addEventListener('click', function () {
          const nextUrl = loadMoreButton.getAttribute('data-next-url');
          if (!nextUrl) return;

          const buttonText = loadMoreButton.querySelector('.load-more-button__text');
          const buttonLoader = loadMoreButton.querySelector('.load-more-button__loader');
          const productGrid = document.querySelector('.product-grid');

          // Show loading state
          loadMoreButton.disabled = true;
          if (buttonText) buttonText.style.display = 'none';
          if (buttonLoader) buttonLoader.style.display = 'inline-block';

          // Fetch next page
          fetch(nextUrl)
            .then((response) => response.text())
            .then((html) => {
              const tempDiv = document.createElement('div');
              tempDiv.innerHTML = html;

              // Get new products from the response
              const newProductGrid = tempDiv.querySelector('.product-grid');
              const newLoadMoreButton = tempDiv.querySelector('.load-more-button');

              if (newProductGrid && productGrid) {
                // Append new products to existing grid
                const newProducts = newProductGrid.querySelectorAll('.collection-product-card-item');
                newProducts.forEach((product) => {
                  // Clone the node to avoid moving it from the temp div
                  const clonedProduct = product.cloneNode(true);
                  productGrid.appendChild(clonedProduct);
                });
              }

              // Update or show "No More Products" message
              if (newLoadMoreButton) {
                loadMoreButton.setAttribute('data-next-url', newLoadMoreButton.getAttribute('data-next-url') || '');
                // Reset button state
                loadMoreButton.disabled = false;
                if (buttonText) {
                  buttonText.textContent = 'Load More';
                  buttonText.style.display = 'inline';
                }
                if (buttonLoader) buttonLoader.style.display = 'none';
              } else {
                // No more pages, show "No More Products" text
                loadMoreButton.disabled = true;
                if (buttonText) {
                  buttonText.textContent = 'No More Products';
                  buttonText.style.display = 'inline';
                }
                if (buttonLoader) buttonLoader.style.display = 'none';
                loadMoreButton.removeAttribute('data-next-url');
              }
            })
            .catch((error) => {
              console.error('Error loading more products:', error);
              // Reset button state on error
              loadMoreButton.disabled = false;
              if (buttonText) buttonText.style.display = 'inline';
              if (buttonLoader) buttonLoader.style.display = 'none';
            });
        });
      }
    }

    // Attach load more listener on initial load
    attachLoadMoreListener();
  });
 
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // AJAX Sort Functionality - No Page Refresh
  document.addEventListener('DOMContentLoaded', function () {
    const sortSelect = document.querySelector('.sort-select');
    if (sortSelect) {
      sortSelect.addEventListener('change', function (e) {
        e.preventDefault();

        const selectedValue = e.target.value;
        const currentUrl = new URL(window.location.href);
        currentUrl.searchParams.set('sort_by', selectedValue);

        // Show loading state
        const productGrid = document.querySelector('.product-grid');
        if (productGrid) {
          productGrid.style.opacity = '0.5';
          productGrid.style.pointerEvents = 'none';
        }

        // Fetch new content
        fetch(currentUrl.toString())
          .then((response) => response.text())
          .then((html) => {
            // Create a temporary div to parse the response
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = html;

            // Find the product grid in the response
            const newProductGrid = tempDiv.querySelector('.product-grid');
            const newLoadMoreContainer = tempDiv.querySelector('.load-more-container');

            if (newProductGrid && productGrid) {
              // Replace the product grid
              productGrid.outerHTML = newProductGrid.outerHTML;
            }

            // Update Load More button
            const currentLoadMoreContainer = document.querySelector('.load-more-container');
            if (newLoadMoreContainer) {
              if (currentLoadMoreContainer) {
                currentLoadMoreContainer.outerHTML = newLoadMoreContainer.outerHTML;
              } else {
                const resultsList = document.querySelector('results-list');
                if (resultsList) {
                  resultsList.insertAdjacentHTML('afterend', newLoadMoreContainer.outerHTML);
                }
              }
            } else if (currentLoadMoreContainer) {
              currentLoadMoreContainer.remove();
            }

            // Update URL without page refresh
            window.history.pushState({}, '', currentUrl.toString());

            // Reset loading state
            const updatedProductGrid = document.querySelector('.product-grid');
            if (updatedProductGrid) {
              updatedProductGrid.style.opacity = '1';
              updatedProductGrid.style.pointerEvents = 'auto';
            }

            // Re-attach event listeners
            attachSortListeners();
            attachLoadMoreListener();
          })
          .catch((error) => {
            console.error('Error:', error);
            // Fallback to page refresh if AJAX fails
            window.location.href = currentUrl.toString();
          });
      });
    }

    function attachSortListeners() {
      const sortSelect = document.querySelector('.sort-select');
      if (sortSelect) {
        sortSelect.addEventListener('change', function (e) {
          e.preventDefault();

          const selectedValue = e.target.value;
          const currentUrl = new URL(window.location.href);
          currentUrl.searchParams.set('sort_by', selectedValue);

          // Show loading state
          const productGrid = document.querySelector('.product-grid');
          if (productGrid) {
            productGrid.style.opacity = '0.5';
            productGrid.style.pointerEvents = 'none';
          }

          // Fetch new content
          fetch(currentUrl.toString())
            .then((response) => response.text())
            .then((html) => {
              // Create a temporary div to parse the response
              const tempDiv = document.createElement('div');
              tempDiv.innerHTML = html;

              // Find the product grid in the response
              const newProductGrid = tempDiv.querySelector('.product-grid');
              const newLoadMoreContainer = tempDiv.querySelector('.load-more-container');

              if (newProductGrid && productGrid) {
                // Replace the product grid
                productGrid.outerHTML = newProductGrid.outerHTML;
              }

              // Update Load More button
              const currentLoadMoreContainer = document.querySelector('.load-more-container');
              if (newLoadMoreContainer) {
                if (currentLoadMoreContainer) {
                  currentLoadMoreContainer.outerHTML = newLoadMoreContainer.outerHTML;
                } else {
                  const resultsList = document.querySelector('results-list');
                  if (resultsList) {
                    resultsList.insertAdjacentHTML('afterend', newLoadMoreContainer.outerHTML);
                  }
                }
              } else if (currentLoadMoreContainer) {
                currentLoadMoreContainer.remove();
              }

              // Update URL without page refresh
              window.history.pushState({}, '', currentUrl.toString());

              // Reset loading state
              const updatedProductGrid = document.querySelector('.product-grid');
              if (updatedProductGrid) {
                updatedProductGrid.style.opacity = '1';
                updatedProductGrid.style.pointerEvents = 'auto';
              }

              // Re-attach event listeners
              attachSortListeners();
              attachLoadMoreListener();
            })
            .catch((error) => {
              console.error('Error:', error);
              // Fallback to page refresh if AJAX fails
              window.location.href = currentUrl.toString();
            });
        });
      }
    }

    // Load More functionality
    function attachLoadMoreListener() {
      const loadMoreButton = document.querySelector('.load-more-button');
      if (!loadMoreButton) return;

      // Skip if listener already attached
      if (loadMoreButton.hasAttribute('data-listener-attached')) return;
      loadMoreButton.setAttribute('data-listener-attached', 'true');

      loadMoreButton.addEventListener('click', function (e) {
        e.preventDefault();

        const currentPage = parseInt(loadMoreButton.getAttribute('data-current-page')) || 1;
        const totalPages = parseInt(loadMoreButton.getAttribute('data-total-pages')) || 1;
        const nextPage = currentPage + 1;

        if (nextPage > totalPages) {
          loadMoreButton.disabled = true;
          loadMoreButton.textContent = 'No More Products';
          return;
        }

        // Disable button and show loading state
        loadMoreButton.disabled = true;
        loadMoreButton.textContent = 'Loading...';

        // Build URL for next page
        const currentUrl = new URL(window.location.href);
        currentUrl.searchParams.set('page', nextPage);

        // Fetch next page
        fetch(currentUrl.toString())
          .then((response) => response.text())
          .then((html) => {
            // Create a temporary div to parse the response
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = html;

            // Find the product grid in the response
            const newProductGrid = tempDiv.querySelector('.product-grid');
            const productGrid = document.querySelector('.product-grid');

            if (newProductGrid && productGrid) {
              // Extract product cards from the new grid
              const newProducts = Array.from(newProductGrid.querySelectorAll('.collection-product-card-item'));
              
              if (newProducts.length > 0) {
                // Append each product to the existing grid
                newProducts.forEach((product) => {
                  productGrid.appendChild(product);
                });

                // Update button state
                const newLoadMoreButton = tempDiv.querySelector('.load-more-button');
                if (newLoadMoreButton) {
                  const newCurrentPage = parseInt(newLoadMoreButton.getAttribute('data-current-page')) || nextPage;
                  const newTotalPages = parseInt(newLoadMoreButton.getAttribute('data-total-pages')) || totalPages;
                  
                  loadMoreButton.setAttribute('data-current-page', newCurrentPage);
                  loadMoreButton.setAttribute('data-total-pages', newTotalPages);

                  if (newCurrentPage >= newTotalPages) {
                    loadMoreButton.disabled = true;
                    loadMoreButton.textContent = 'No More Products';
                  } else {
                    loadMoreButton.disabled = false;
                    loadMoreButton.textContent = 'Load More';
                  }
                } else {
                  // No more pages
                  loadMoreButton.disabled = true;
                  loadMoreButton.textContent = 'No More Products';
                }
              } else {
                // No products found in response
                loadMoreButton.disabled = true;
                loadMoreButton.textContent = 'No More Products';
              }
            } else {
              // No product grid found
              loadMoreButton.disabled = true;
              loadMoreButton.textContent = 'No More Products';
            }
          })
          .catch((error) => {
            console.error('Error loading more products:', error);
            loadMoreButton.disabled = false;
            loadMoreButton.textContent = 'Load More';
          });
      });
    }

    // Initialize Load More listener
    attachLoadMoreListener();
  });

  } catch(e) { console.error(e); }
})();
})();
